export const en = {
  'page-not-found': 'Page not found',
  'error': 'Error',
  'no-access': 'You have no access',
  'internal-server-error': 'Internal server error',
}
